<script>
    import R, {LOADER} from "../../lib/requests";
    import user from "../../stores/user";
    import PageHeader from "../../components/PageHeader.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import TableHeader from "../../components/TableHeader.svelte";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import {sort} from "../../lib/lib";
    import UserModal from "./UserModal.svelte";

    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: '', title: ''},
    ];

    let users = null;
    let userId = 0;
    let editId = null;

    const load = () => {

        const onSuccess = result => {
            users = result;
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, {}, onSuccess, onFailure, LOADER.PAGE);
    };


    const onCreate = () => {
        editId = 0;
    };

    const onEdit = (obj) => {
        if (obj.id === $user.id) {
            Alert.warning("Επεξεργασία λογαριασμού", 'Για να αλλάξετε τα στοιχεία του λογαριασμού σας μεταφερθείτε στην σελίδα "Ο Λογαριασμός μου".');
            return;
        }

        userId = obj.id;
        editId = obj.id;
    };

    const closeEdit = param => {
        if (param) {
            if (editId == 0) {
                load();
            } else {
                let item = users.find(x => x.id == param.id);
                if (item) {
                    item.name = param.name;
                }
                users = users;
            }
        }
        editId = null;
    }


    const onColumnSort = ({detail: column}) => {
        users = sort(users, column.key, column.sort_way === 'DESC');
    };

    const onDelete = (obj) => {
        const onSuccess = result => {
            let message = '';
            if (result.projects && result.projects > 0) {
                message = `Ο χρήστης είναι συνδεμένος με ${result.projects} ${result.projects > 1 ? 'projects' : 'project'}.\n`;
            }
            Alert.delete("Διαγραφή χρήστη", `${message}Να διαγραφτεί οριστικά ο χρήστης "${obj.name}";`, () => deleteUser(obj.id));
        }

        const onFailure = err => {
        };

        if (obj.id === $user.id) {
            Alert.warning("Διαγραφή χρήστη", "Δεν μπορείτε να διαγράψετε τον λογαριασμό σας!");
            return;
        }

        R.handle(R.user.relations, obj.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const deleteUser = (id) => {
        const onSuccess = result => {
            users = users.filter(x => x.id !== result);
            Notifier.showMessage("Ο χρήστης διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.user.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Χρήστες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if users}
    {#if users.length}
        <table class="table table-list table-list-border">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>

            {#each users as item}
                <tr class="row-hover" class:row-selected="{ userId === item.id }">
                    <td>
                        <div class="is-link" on:click="{ () => onEdit(item) }">{ item.name }</div>
                    </td>
                    <td class="button-column">
                        <div class="button" title="διαγραφή" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash"/>
                        </div>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        <div class="panel panel-default box-border">
            <div class="panel-body panel-pad">
                Δεν βρέθηκαν χρήστες
            </div>
        </div>
    {/if}
{/if}
{#if editId != null}
    <UserModal userId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

